<h2 mat-dialog-title>{{ data.title }}</h2>

<mat-dialog-content>
	<p>{{ data.message }}</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
	<button mat-button (click)="onCancel()">
		{{ data.cancelText ?? defaultCancelText }}
	</button>
	<button matButton="elevated" color="warn" (click)="onConfirm()">
		{{ data.confirmText ?? defaultConfirmText }}
	</button>
</mat-dialog-actions>
